export default __webpack_public_path__ + "static/media/Father.c97204c8.svg";